import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import logo from "../components/css/logoImg.jpeg";
import Certification from "./certification";

export const Navigation = (props) => {
  const whatsappNumber = "918680907810";

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a
            className="navbar-brand page-scroll"
            href="#page-top"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "60px",
                height: "60px",
                marginRight: "10px",
                verticalAlign: "middle",
              }}
            />
            {/* <span style={{ fontSize: "20px", fontWeight: "bold" }}>
              VSR Global Link
            </span> */}
            <span
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                background: "linear-gradient(90deg, #ff8a00, #e52e71)",
                WebkitBackgroundClip: "text",
                color: "transparent",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                fontFamily: "'Poppins', sans-serif",
                letterSpacing: "1px",
              }}
            >
              VSR Global Link
            </span>
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              {/* <a href="#certification" className="page-scroll">
                Accolades & Accreditation
              </a> */}
              <a href="#certification" className="page-scroll">
                Certificates
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#products" className="page-scroll">
                Products
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <FaWhatsapp size={30} color="#25D366" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
